export { AccommodationDetailTemplate } from './AccommodationDetailTemplate';
export type {
  AccommodationDetailListItem,
  AccommodationDetailTemplateProps,
} from './AccommodationDetailTemplate.types';
